;(function(){
  
  const section_header = document.getElementById('section-header');
  window.addEventListener('scroll', function () {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const header_wrapper_height = document.querySelector('.Header__Wrapper').offsetHeight;
    const __header_height = parseInt(
      document.documentElement.style.getPropertyValue('--header-height')
    );

    if (scrollTop > 0) {
      section_header.classList.add('section-header-fixed');

      // 非表示にする部分の高さを差し引く
      if (__header_height > header_wrapper_height) {
        document.documentElement.style.setProperty('--header-height', `${header_wrapper_height}px`);
      }
    } else {
      section_header.classList.remove('section-header-fixed');

      // 再表示する部分の高さを追加
      const section_header_height = document.getElementById('section-header').offsetHeight;
      if (__header_height < section_header_height) {
        document.documentElement.style.setProperty('--header-height', `${section_header_height}px`);
      }
    }
  });
  
    
})()